import React from 'react';
import { Icon } from '@tesla/design-system-react';
import { iconPlusSmall } from '@tesla/design-system-icons';
import { ArrayField, FormField } from 'informed';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import messages from './messages';
import style from './style.module.scss';

const ProfileLinks = ({ initialValue, label, types, max, validate, profileLinks, ...props }) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const schema = {
    type: 'object',
    properties: {
      type: {
        type: 'select',
        title: formatMessage(messages.LinkTypeLabel),
        oneOf: types,
        errorMessage: {
          required: formatMessage(messages.TypeRequiredMessage),
        },
      },
      link: {
        type: 'string',
        title: label,
        errorMessage: {
          required: formatMessage(messages.LinkRequiredMessage),
        },
      },
    },
  };

  return (
    <div className={style.ProfileLinks}>
      <ArrayField {...props} initialValue={initialValue}>
        {({ add, arrayFieldState: { fields: items } }) => (
          <>
            <ArrayField.Items>
              {({ index, remove, values: item }) => (
                <div className={`${style.ProfileLink}`}>
                  {max > 1 && (
                    <div className={`${style.CaptionWrapper}`}>
                      <span
                        className={`tds-text--caption tds-text--500 tds-text--contrast-high ${style.Caption}`}
                      >
                        {formatMessage(messages.Caption, {
                          index: index + 1,
                        })}
                      </span>
                      <button className={`tds-link ${style.Remove}`} type="button" onClick={remove}>
                        {formatMessage(messages.RemoveButton)}
                      </button>
                    </div>
                  )}
                  <div className={`${style.LinkWrapper}`}>
                    <FormField
                      name="link"
                      schema={{ properties: { link: schema.properties.link } }}
                      required={item && item.type && item.type !== ''}
                      validate={validate}
                    />
                  </div>
                  <div className={`${style.TypeWrapper}`}>
                    <FormField
                      name="type"
                      schema={{ properties: { type: schema.properties.type } }}
                      required={item && item.link && item.link !== ''}
                    />
                  </div>
                </div>
              )}
            </ArrayField.Items>
            {max > 1 && (
              <button
                className={`tds-icon-trigger tds-icon-trigger--small ${style.Add}`}
                type="button"
                onClick={add}
                disabled={items.length >= max}
              >
                <Icon data={iconPlusSmall} className={`${style.Icon} ${style.IconWithCircle}`} />
                <span className={`${style.AddLabel}`}>
                  {items.length > 0
                    ? formatMessage(messages.AddMoreButton)
                    : formatMessage(messages.AddButton)}
                </span>
              </button>
            )}
          </>
        )}
      </ArrayField>
    </div>
  );
};

ProfileLinks.propTypes = {
  initialValue: arrayOf(
    shape({
      type: string,
      link: string,
    })
  ),
  label: string,
  types: arrayOf(
    shape({
      const: string,
      title: string,
    })
  ).isRequired,
  max: oneOfType([number, string]),
  validate: func,
  name: string.isRequired,
  profileLinks: shape({}),
};

ProfileLinks.defaultProps = {
  initialValue: [],
  label: '',
  max: 10,
  validate: null,
  profileLinks: {},
};

export default ProfileLinks;
